export const dealStatusValues = ['active', 'canceled', 'closed'];
